import React, { Component } from "react";
import { AvField, AvForm, AvInput } from "availity-reactstrap-validation";
import { Button, Card, CardBody, CardTitle, Col, FormGroup, Label } from "reactstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Select from "react-select";
import { withNamespaces } from "react-i18next";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { faces_ID, faces_names, face_num_name } from "../../constants/faces_types";
import { getAllRacks, getWorkstations, updateTask } from "../../store/actions";
import Loader from "../Common/Loader";

class UpdateTaskForm extends Component {
  constructor(props) {
    super(props);
    const { query } = this.props.location;
    if (!query) {
      this.props.history.push("/tasks");
    }

    this.state = {
      user: JSON.parse(localStorage.getItem("authUser")),
      popup: false,
      pop_msg: "",
      origin_page: query.page_origin,
      task: this.props.location.query.task,
      selectedOptions: [],
      options: [],
      racks: [],
    };
  }

  componentDidMount() {
    const { user } = this.state;
    this.props.getWorkstations(user);
    this.props.getAllRacks(user);
  }

  componentDidUpdate(prevProps) {
    this.handleWorkstationsResponse(prevProps);
    this.handleRacksResponse(prevProps);
    this.handleTaskUpdateResponse(prevProps);
  }

  handleWorkstationsResponse(prevProps) {
    const { loadingGetWs, ws } = this.props;
    if (!loadingGetWs && prevProps.loadingGetWs && ws) {
      if (ws.length === 0) {
        this.props.history.push("/tasks");
      } else {
        const selectedWorkstations = this.state.task.workstationCandidates.split(",");
        const availableWorkstations = ws.filter((ws) => !selectedWorkstations.includes(ws.name));
        this.setState({
          options: availableWorkstations.map((element) => ({
            label: element.name,
            value: element.name,
          })),
          ws,
          selectedOptions: selectedWorkstations.map((wsName) => ({
            label: wsName,
            value: wsName,
          })),
        });
      }
    }
  }

  handleRacksResponse(prevProps) {
    const { loadingGetAllRacks, racks } = this.props;
    if (!loadingGetAllRacks && prevProps.loadingGetAllRacks && racks) {
      this.setState({ racks });
    }
  }

  handleTaskUpdateResponse(prevProps) {
    const { loadingUpdateTask, messageTask, updateTaskError } = this.props;
    if (!loadingUpdateTask && prevProps.loadingUpdateTask) {
      const taskRejectedMsg =
        updateTaskError?.numberTasksRejected > 0 ? this.props.t("TaskRejectedCheckParameters") : "";

      this.setState({
        popup: true,
        pop_msg: messageTask
          ? this.props.t("Tarea actualizada correctamente")
          : `Error al actualizar la tarea ${taskRejectedMsg}`,
      });
    }
  }

  handleValidSubmit = (event, values) => {
    const { user, selectedOptions } = this.state;
    values.workstationCandidates = selectedOptions.map((element) => element.value);
    values.estimatedDurationSeconds = values.estimatedDurationSeconds || null;

    console.log({ values });

    this.props.updateTask(values, user.token, this.props.history);
  };

  handleChange = (selectedOptions) => {
    // Detectar la estación de trabajo eliminada (deja de estar en selectedOptions)
    const removedWorkstations = this.state.selectedOptions.filter(
      (ws) => !selectedOptions.find((selected) => selected.value === ws.value)
    );

    // Detectar la nueva estación de trabajo añadida (no estaba en selectedOptions)
    const addedWorkstations = selectedOptions.filter(
      (ws) => !this.state.selectedOptions.find((selected) => selected.value === ws.value)
    );

    // Actualizar `selectedOptions` y `options`
    this.setState((prevState) => {
      // Mover las estaciones de trabajo eliminadas de `selectedOptions` a `options`
      const updatedOptions = [...prevState.options, ...removedWorkstations];
      // Filtrar las estaciones eliminadas de `selectedOptions`
      const updatedSelectedOptions = selectedOptions;

      // Filtrar las opciones para eliminar las seleccionadas
      const filteredOptions = updatedOptions.filter(
        (option) => !updatedSelectedOptions.find((selected) => selected.value === option.value)
      );

      return {
        selectedOptions: updatedSelectedOptions,
        options: filteredOptions,
      };
    });
  };

  confirmPopup = () => {
    this.setState({ popup: false });
    this.props.history.push("/tasks");
  };

  renderLoader() {
    return (
      <div className="loaderCenter">
        <Loader />
      </div>
    );
  }

  renderSelectOptions(label, name, options, defaultValue, handleChange) {
    return (
      <Col>
        <FormGroup>
          <Label>{this.props.t(label)}</Label>
          <Select
            name={name}
            value={defaultValue} // Establecer las opciones seleccionadas por defecto
            isMulti
            placeholder={this.props.t("SelectWorkstations")}
            onChange={handleChange}
            options={options}
          />
        </FormGroup>
      </Col>
    );
  }

  renderForm() {
    const { task, options, racks, selectedOptions } = this.state;

    console.log("faces_ID:", faces_ID);
    console.log("task.face:", task.face);
    console.log("faces_names:", faces_names);
    console.log("faces_names[task.face]:", faces_names[face_num_name[task.face]]);
    console.log("face_num_names:", face_num_name[task.face]);

    return (
      <AvForm className="needs-validation" onValidSubmit={this.handleValidSubmit}>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Identificador")}</Label>
            <AvField
              value={task.taskCode}
              name="taskCode"
              placeholder="Identificador"
              type="text"
              disabled
              validate={{ required: { value: true } }}
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Prioridad")}</Label>
            <AvInput
              name="priority"
              type="number"
              placeholder="Prioridad"
              validate={{ required: { value: true } }}
              value={task.priority}
            />
          </FormGroup>
        </Col>
        {this.renderSelectOptions("Estación de trabajo", "sgpWS", options, selectedOptions, this.handleChange)}
        <Col>
          <FormGroup>
            <Label>{this.props.t("Estimación de tiempo (segundos)")}</Label>
            <AvInput
              name="estimatedDurationSeconds"
              type="number"
              placeholder="Estimación de la tarea"
              value={task.estimatedDurationSeconds}
            />
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Racks")}</Label>
            <AvInput name="rackCode" type="select" defaultValue={task.rackCode} validate={{ required: { value: true } }}>
              {racks.map((rack) => (
                <option key={rack.rackCode} value={rack.rackCode}>
                  {rack.rackCode}
                </option>
              ))}
            </AvInput>
          </FormGroup>
        </Col>
        <Col>
          <FormGroup>
            <Label>{this.props.t("Cara")}</Label>
            <AvInput
              name="face"
              type="select"
              value={face_num_name[task.face]} // Mapea task.face al nombre adecuado usando face_num_name
              validate={{ required: { value: true } }}
            >
              {faces_ID.map((face) => (
                <option key={face} value={face}>
                  {faces_names[face]}
                </option>
              ))}
            </AvInput>
          </FormGroup>
        </Col>
        <Button color="primary" type="submit" className="createButton">
          {this.props.t("Modificar tarea")}
        </Button>
      </AvForm>
    );
  }

  renderAlert() {
    return (
      <SweetAlert
        type={this.state.pop_msg ? "success" : "error"}
        title={this.state.pop_msg || "Error al modificar la tarea"}
        confirmBtnText={this.props.t("ok")}
        onConfirm={this.confirmPopup}
      />
    );
  }

  render() {
    const { popup, racks, ws, task } = this.state;

    return (
      <Col lg="12">
        <Card>
          <CardBody>
            <CardTitle className="mb-4">{this.props.t("Modificar tarea")}</CardTitle>
            {!ws || !racks || !task ? this.renderLoader() : this.renderForm()}
            {popup && this.renderAlert()}
          </CardBody>
        </Card>
      </Col>
    );
  }
}

const mapStateToProps = (state) => ({
  loadingUpdateTask: state.UpdateTask.loadingUpdateTask,
  messageTask: state.UpdateTask.messageTask,
  updateTaskError: state.UpdateTask.updateTaskError,
  loadingGetWs: state.GetWS.loadingGetWs,
  ws: state.GetWS.ws,
  loadingGetAllRacks: state.getAllRacks.loadingGetAllRacks,
  racks: state.getAllRacks.racks,
});

export default withRouter(
  connect(mapStateToProps, { updateTask, getWorkstations, getAllRacks })(withNamespaces()(UpdateTaskForm))
);
